$(() => {
    $('.tabs__pane').each(function () {
        new Tabs($(this))
    })
})

class Tabs {
    constructor($elem) {
        this.$elem = $elem;
        this.initTab();
        this.initEvents();
    }

    initTab() {
        // open tab
        this.$elem.on('tab:open', (e) => {
            this.$elem.addClass('is-active');
            this.$elem.siblings().trigger('tab:close')
        })

        // close tab
        this.$elem.on('tab:close', (e) => {
            this.$elem.removeClass('is-active');
            let navItem = this.$elem.attr('aria-labelledby');

            if (navItem !== undefined) {
                this.deActivateNav($('#' + navItem));
            }
        })
    }

    initEvents() {
        $("[data-toggle='tab']").on('click', (e) => {
            event.preventDefault();
            let $this = $(e.currentTarget);

            // get anchor
            let target = $this.attr('href');

            // get button
            if (target === undefined) {
                target = $this.data('target');
            }

            // trigger event
            if (target !== undefined) {
                $(target).trigger('tab:open');
            }

            // update navigation
            this.activateNav($('a[href="' + target + '"]'));
            this.activateNav($('*[data-target="' + target + '"]'));
        })
    }

    // activate navigation
    activateNav($elem) {
        $elem.addClass('is-active');
        $elem.attr('aria-selected', true);
    }

    // deActivate navigation
    deActivateNav($elem) {
        $elem.removeClass('is-active');
        $elem.attr('aria-selected', false);
    }
}